import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=20f9e4ff&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f9e4ff')) {
      api.createRecord('20f9e4ff', component.options)
    } else {
      api.reload('20f9e4ff', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=20f9e4ff&", function () {
      api.rerender('20f9e4ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P4lnR0dAT7V1/JS/comp/IncreaseNumber.vue"
export default component.exports